// src/components/Footer/Footer.jsx
import React from 'react';
import styles from './Footer.module.css';
import { useLanguage } from '../../context/LanguageContext';

// 从 react-icons 库中导入图标
import { FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { FiMail } from 'react-icons/fi';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className={styles.footer}>
      <div className={`container mx-auto px-4 ${styles.footerGrid}`}>

        {/* INFO 栏 */}
        <div className={styles.footerColumn}>
          <h3 className={styles.footerTitle}>{t('footer.info')}</h3>
          <ul className={styles.navList}>
            <li className={styles.navItem}><a href="/draft">{t('header.draft')}</a></li>
            <li className={styles.navItem}><a href="/story">{t('header.story')}</a></li>
            <li className={styles.navItem}><a href="/qa">{t('header.qa')}</a></li>
            <li className={styles.navItem}><a href="/social">{t('footer.socialOrg')}</a></li>
          </ul>
        </div>

        {/* SOCIAL 栏 */}
        <div className={styles.footerColumn}>
          <h3 className={styles.footerTitle}>{t('footer.social')}</h3>
          <ul className={styles.navList}>
            <li className={styles.navItem}>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
                <FaFacebookF /> <span>Facebook</span>
              </a>
            </li>
            <li className={styles.navItem}>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
                <FaInstagram /> <span>Instagram</span>
              </a>
            </li>
            <li className={styles.navItem}>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
                <FaLinkedinIn /> <span>LinkedIn</span>
              </a>
            </li>
            <li className={styles.navItem}>
              <a href="mailto:thewoodendiary@gmail.com" className={styles.socialLink}>
                <FiMail /> <span>e-mail</span>
              </a>
            </li>
          </ul>
        </div>

      </div>
    </footer>
  );
}